import React from "react";

// Returns a React SVG component so that we may change the fill color and/or icon size of the SVG to whatever we want dynamically across hundreds of different websites and hundreds of different colors.
// This react component is the box SVG icon, typically used for the Order CTA.

const TorqueDefault = ({ fill, svgIconSize }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1193.823 820"
            enableBackground="new 0 0 1193.823 820"
            xmlSpace="preserve"
            style={{
                width: svgIconSize,
                height: svgIconSize,
                fill: fill,
                pointerEvents: "none",
            }}
        >
            <rect
                x="-701.809"
                y="-867.26"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1096.3826 765.479)"
                display="none"
            />
            <g>
                <g>
                    <path
                        d="M695.498,16.764H311.043c-60.647,0-114.812,38.468-134.795,95.713l-32.988,94.582l-16.559-20.402
                    c-6.621-7.3-16.117-11.692-26.528-11.821c-15.374-0.226-22.631-0.269-37.951,0.603c-25.365,1.453-37.295,8.818-34.926,35.647
                    c2.39,26.647,18.292,49.159,78.454,50.85c-54.327,24.504-81.404,78.874-93.775,154.088c-0.258,1.292-0.409,2.584-0.743,3.876
                    C-7.189,515.773-9.902,598.286,57.861,631.102v52.411c0,26.324,21.339,47.673,47.673,47.673h125.977
                    c26.335,0,47.673-21.35,47.673-47.673V647.66h96.423c3.219-12.629,7.967-24.999,14.244-36.853
                    c13.555-25.592,33.57-47.297,57.88-62.789c18.163-11.574,38.49-19.541,59.624-23.47L654.36,247.432H194.411l40.008-114.651
                    c11.348-32.557,42.15-54.424,76.624-54.424h363.795c2.939-8.893,6.632-17.56,11.046-25.904
                    c6.718-12.672,15.019-24.397,24.644-34.883C705.575,17.033,700.558,16.764,695.498,16.764z M292.438,480.319
                    c-2.982,25.042-53.713,23.664-118.538,19.702c-86.874-5.308-111.97-14.384-112.293-61.293
                    c-0.161-25.226,23.072-59.441,121.046-35.346C245.723,418.886,295.421,455.277,292.438,480.319z"
                    />
                </g>
                <path
                    d="M1144.806,593.76l49.017-7.001v-71.362l-49.017-7c-3.735-16.154-10.204-31.236-18.566-44.969l29.611-39.314l-50.335-50.629
                l-39.603,29.622c-13.727-8.348-28.822-14.81-44.967-18.578l-6.997-48.742h-71.37l-6.996,48.742
                c-16.146,3.768-31.24,10.23-44.969,18.578l-39.287-29.622l-50.65,50.629l29.611,39.314c-8.625,13.733-14.779,28.815-18.567,44.969
                l-48.754,7v71.362l48.754,7.001c3.788,16.156,9.942,31.239,18.567,45.242l-29.611,39.313l50.65,50.356l39.287-29.62
                c13.729,8.619,28.823,15.082,44.969,18.849l6.996,48.741h71.37l6.997-48.741c16.145-3.767,31.24-10.23,44.967-18.849l39.603,29.62
                l50.335-50.356l-29.611-39.583C1134.602,624.729,1141.071,609.647,1144.806,593.76z M978.396,605.862
                c-30.35,0-54.714-24.485-54.714-54.715c0-30.228,24.364-54.85,54.714-54.85c30.242,0,54.714,24.622,54.714,54.85
                C1033.109,581.377,1008.637,605.862,978.396,605.862z"
                />
                <path
                    d="M527.767,819.621c50.33,3.846,100.516-21.761,125.65-69.214c22.289-42.067,19.305-90.793-3.579-128.81l191.04-360.128
                c44.306-2.428,86.291-27.334,108.57-69.407c25.134-47.452,18.123-103.355-13.335-142.831l-46.861,88.471l-60.122,2.216
                L797.021,88.85l46.854-88.471c-50.324-3.845-100.508,21.76-125.643,69.213c-22.285,42.073-19.305,90.793,3.578,128.811
                L530.771,558.531c-44.306,2.427-86.285,27.334-108.57,69.408c-25.134,47.452-18.122,103.354,13.331,142.824l46.865-88.466
                l60.287-2.13l31.945,50.982L527.767,819.621z"
                />
            </g>
        </svg>
    );
};

export default TorqueDefault;
